import { useQuery } from "@tanstack/react-query";
import { RequestDetailsView } from "components/RequestDetails/RequestDetailsView";
import { Settings } from "luxon";
import { RequestModel } from "model";
import { useParams } from "react-router-dom";
import { fetchRequest } from "utils/api";

import { Loader } from "~components/Atoms";

type RequestDetailsParam = {
  requestId: string;
};

export function RequestDetails() {
  const { requestId } = useParams<RequestDetailsParam>();

  const { data: request } = useQuery({
    queryKey: ["requests", requestId],
    queryFn: async () => {
      const { data } = await fetchRequest({
        requestId: requestId || "",
        includeActivity: false,
      }).then((resp) => resp);
      return data;
    },
    select: (data) => {
      const requestModel = new RequestModel(data);
      Settings.defaultZone = requestModel.school.tzString;
      return requestModel;
    },
  });

  if (!request) return <Loader />;

  // Redirect to past request details URL if the active requests URL
  // contains a past request uuid
  if (request.isPast() && window.location.hash.match(/#\/active-requests\/([0-9a-fA-F-]{36})/)) {
    window.location.replace(window.location.toString().replace("active-requests", "past-requests"));
  }

  return (
    <div className="page">
      <RequestDetailsView request={request} />
    </div>
  );
}
